import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import moment from 'moment';
import * as Routes from '@/modules/routes';
import { UserType } from '../types';

interface UseAssignmentsProps {
  classroomId: number;
  programId: number;
  user: UserType;
}

export const assignmentsQueryKey = ({ classroomId, programId, user }: UseAssignmentsProps) => (
  ['assignments', user.id, classroomId, programId, user.type]
);

export const useAssignments = ({ classroomId, programId, user }: UseAssignmentsProps) => {
  const isStudent = user.type === 'Student';

  return useQuery({
    queryFn: async () => {
      const onlyFields = [
        'assignment_location_title',
        'assignment_models_hash',
        'assignment_title',
        'assignment_unit_lesson',
        'dates_enforced',
        'due_datetime',
        'id',
        'notes',
        'staffer_id',
        'start_datetime',
        'status',
        'teacher_display_name',
      ];

      const route = isStudent
        ? Routes.plato_api_student_index_student_assignments_path(user.id, {
          for_classroom: classroomId,
          in_program: programId,
          only: onlyFields,
        })
        : Routes.plato_api_staffer_assignments_path(user.id, {
          in_program: programId,
          local_time_zone: moment.tz.guess(),
          only: onlyFields,
        });

      const response = await axios.get(route);
      return response.data.data;
    },
    queryKey: assignmentsQueryKey({ classroomId, programId, user }),
  });
};
